

function BoxButton({ text, chooseCancel, chooseAction }) {
    return (
        <div className="flex flex-row-reverse justify-around mt-5">
            <button
                onClick={chooseAction}
                className="bg-purpleDark text-white font-bold rounded-lg w-56 py-2 shadow"
            >{text}</button>
            <button
                onClick={() => chooseCancel("")}
                className="w-56 py-2 bg-white font-bold t-purpleDark shadow border-2 border-blue-500 rounded-lg"
            >لغو</button>
        </div>
    )
}
export default BoxButton;